import React, { useEffect, useState } from "react";
import copy from "simple-copy-to-clipboard";
import cn from "classnames";

import { Plate } from "../helpfull/Plate";
import { HeaderTitle } from "../helpfull/HeaderTitle";
import { AnalyticsButton } from "../helpfull/AnalyticsButton";
import { TinyButton } from "../helpfull/TinyButton";

import { getPeople, postContactMoment as postRawContactMoment } from "./utils";
import { config } from "./utils";

import BEM from "./Relationships.module.scss";
import headingicon from "./assets/headingicon.svg";

export const Relationships = () => {
    const [people, setPeople] = useState("loading");
    const [isFolded, setIsFolded] = useState(true);
    const [isAnalVisible, setIsAnalVisible] = useState(false);
    const [textAriaValue, setTextAriaValue] = useState("");

    const loadPeople = async () => {
        setPeople("loading");
        const people = await getPeople();
        setPeople(people);
    };

    const postContactMoment = async (id) => {
        setPeople("loading");
        await postRawContactMoment(id);
        loadPeople();
    };

    useEffect(() => {
        loadPeople();
    }, []);

    return (
        <Plate>
            <div className={BEM.block}>
                <header className={BEM.header}>
                    <HeaderTitle title="Стосунки з людьми" icon={headingicon} />
                    <AnalyticsButton
                        onClick={() => setIsAnalVisible(!isAnalVisible)}
                    />
                </header>

                {isAnalVisible && (
                    <div>
                        <button
                            onClick={() =>
                                alert(
                                    copy(localStorage.getItem("stats/people"))
                                        ? "successfully copied"
                                        : "error",
                                )
                            }
                        >
                            Press to copy localStorage STATISTICS
                        </button>
                        <br />
                        <br />
                        <div>
                            <textarea
                                value={textAriaValue}
                                onChange={(event) =>
                                    setTextAriaValue(event.target.value)
                                }
                                className={BEM.textAria}
                                placeholder="paste your config here"
                            ></textarea>
                            <button
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    localStorage.setItem(
                                        "config/relationships",
                                        textAriaValue,
                                    );
                                    location.reload();
                                }}
                            >
                                UPDATE
                            </button>
                        </div>
                    </div>
                )}

                <main className={BEM.content}>
                    {people === "loading" ? (
                        <p className={BEM.loadingMessage}>Loading...</p>
                    ) : (
                        (isFolded ? people.slice(0, 5) : people).map(
                            (person) => (
                                <p key={person.id} className={BEM.person}>
                                    <button
                                        onClick={() =>
                                            postContactMoment(person.id)
                                        }
                                        className={BEM.person_markButton}
                                    >
                                        <svg
                                            width="11"
                                            height="11"
                                            viewBox="0 0 11 11"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="5.5"
                                                cy="5.5"
                                                r="5"
                                                stroke="#fff"
                                            ></circle>
                                        </svg>
                                    </button>
                                    <span className={BEM.person_title}>
                                        {person.title}
                                    </span>
                                    <span className={BEM.person_details}>
                                        <span className={BEM.person_detail}>
                                            <span className={BEM.person_textSm}>
                                                p:
                                            </span>{" "}
                                            <span className={BEM.person_textLg}>
                                                {Number.isInteger(
                                                    person.priority,
                                                )
                                                    ? person.priority
                                                    : person.priority.toFixed(
                                                          1,
                                                      )}
                                            </span>
                                        </span>
                                        <span className={BEM.person_detail}>
                                            <span className={BEM.person_textSm}>
                                                idle:
                                            </span>{" "}
                                            <span className={BEM.person_textLg}>
                                                {person.idleDays}
                                            </span>
                                            <span className={BEM.person_textSm}>
                                                днів
                                            </span>
                                        </span>
                                        <span
                                            className={cn({
                                                [BEM.person_detail]: true,
                                                [BEM.person_detail___red]:
                                                    person.score >
                                                    config.maxScore,
                                            })}
                                        >
                                            <span className={BEM.person_textSm}>
                                                score:
                                            </span>{" "}
                                            <span className={BEM.person_textLg}>
                                                {Math.floor(person.score)}
                                            </span>
                                        </span>
                                    </span>
                                </p>
                            ),
                        )
                    )}

                    <TinyButton
                        className={BEM.tinyBtn}
                        onClick={() => setIsFolded(!isFolded)}
                    >
                        {isFolded ? "Розгорнути" : "Згорнути"}
                    </TinyButton>
                </main>
            </div>
        </Plate>
    );
};
